var encode = require('./encode');
var decode = require('./decode');

exports.encode = encode;
exports.decode = decode;
exports.version = '2.0.0';
